import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-register',
  templateUrl: './common-register.component.html',
  styleUrls: ['./common-register.component.scss']
})
export class CommonRegisterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
